import { notification } from "antd"

const success = (message) => {
    notification.destroy()
    const args = {
        message: 'Success',
        description: message,
        duration: 3,
    };
    notification.success(args)
}

const error = (message, heading = 'Error') => {
    notification.destroy()
    const args = {
        message: heading,
        description: message,
        duration: 3,
    };
    notification.error(args)
}

const info = (message) => {
    notification.destroy()
    const args = {
        message: 'Information',
        description: message,
        duration: 3,
    };
    notification.info(args)
}

export {
    success,
    error,
    info
}